import backgroundUrl from '@/assets/lp-bg.webp';
import type { ThemeTokens } from './theme.entity';

/**
 * O tema padrão de todas as LPs: a paleta do `.e3` do `enamed-feedback-lp`.
 *
 * Os nomes de lá, para quem for comparar: `ink`, `night` e `deep` são os mesmos;
 * `accent` é o `--ice` e `accentStrong` é o `--blue`. Os tons de texto que lá
 * eram hex soltos em cada regra (`#dce5f8`, `#cbd7f0`, `#8c9ac0`…) viraram
 * `soft`, `muted` e `subtle`.
 */
export const defaultTheme: ThemeTokens = {
  ink: '#05081a',
  night: '#08061f',
  deep: '#0b1030',
  text: '#ffffff',
  soft: '#dce5f8',
  muted: '#b4c1e0',
  subtle: '#8c9ac0',
  accent: '#8ed2fa',
  accentStrong: '#2f9be8',
  onAccent: '#06122b',
  ctaGradient: 'linear-gradient(135deg, #a9defc 0%, #6fc4f5 42%, #2f9be8 100%)',
  mark: '#2f6cb3',
  success: '#6ee7a8',
  danger: '#ff8f8f',
  warning: '#facc15',
  backgroundImage: `url(${backgroundUrl})`,
  fontFamily:
    "'Plus Jakarta Sans', system-ui, -apple-system, 'Segoe UI', sans-serif",
};
